// src/pages/mallkiosk/SuccessScreen.js
// Per-stall order numbers, auto-reset to attract.
import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';

const AUTO_RESET_SECS = 10;

export default function SuccessScreen({ orders, total, onReset }) {
  const { t, isAr } = useLanguage();
  const [countdown, setCountdown] = useState(AUTO_RESET_SECS);

  useEffect(() => {
    const t = setInterval(() => {
      setCountdown(c => {
        if (c <= 1) { clearInterval(t); onReset(); }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [onReset]);

  return (
    <div
      onClick={onReset}
      style={{
        position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', background: 'var(--bg)',
        textAlign: 'center', padding: 40, cursor: 'pointer', direction: isAr ? 'rtl' : 'ltr',
      }}>
      <div style={{ fontSize: 100, marginBottom: 24 }}>✅</div>
      <div style={{ fontSize: 42, fontWeight: 800, color: 'var(--green)', marginBottom: 28 }}>
        {t('Orders Placed!', 'تم تقديم الطلب!')}
      </div>

      <div style={{ fontSize: 18, color: 'var(--text2)', marginBottom: 12 }}>{t('Your order numbers:', 'أرقام طلبك:')}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%', maxWidth: 460, marginBottom: 28 }}>
        {orders.map((o, i) => (
          <div key={i} style={{
            background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 16,
            padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}>
            <span style={{ fontSize: 18, color: 'var(--text)' }}>{o.vendorName || o.vendor}</span>
            <span style={{ fontSize: 22, fontWeight: 800, color: 'var(--accent)' }}>{o.orderNumber}</span>
          </div>
        ))}
      </div>

      <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>
        AED {total.toFixed(2)}
      </div>
      <div style={{ fontSize: 16, color: 'var(--text2)', marginBottom: 32 }}>
        {t('Your orders are being prepared 🍽', 'يتم تحضير طلباتك 🍽')}
      </div>

      <div style={{ fontSize: 15, color: 'var(--text3)' }}>
        {t('Returning to start in', 'العودة للبداية خلال')} {countdown}...
      </div>
    </div>
  );
}
